import { render, staticRenderFns } from "./consulting-subscribe-order.vue?vue&type=template&id=10456290&"
import script from "./consulting-subscribe-order.vue?vue&type=script&lang=js&"
export * from "./consulting-subscribe-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports